import { FicheArticle } from '@/model/fiche-article';
import { ParamsCommande } from '@/model/params-commande';
import Axios from 'axios';
import { ApiUtils } from './api-utils';

export class ArticleApi {
  static getFicheArticles (codeRegion: string): Promise<FicheArticle[]> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/fiches-articles?codeRegion=` + codeRegion), [FicheArticle]);
  }

  static getFicheArticle (idArticle: number, codeRegion: string): Promise<FicheArticle> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/fiches-articles/${idArticle}?codeRegion=` + codeRegion), FicheArticle);
  }

  static getParamsCommandeArticle (idArticle: number):Promise<ParamsCommande> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/articles/${idArticle}/parametres-commande`), ParamsCommande);
  }
}
